import React from 'react';
import {Redirect, Route, Switch} from "react-router";
import routes from "../../views/routes";
import CalculatorPageView from "../../views/calculatorPage/CalculatorPageView";
import ErrorPageView from "../../views/errorPage/ErrorPageView";
import './App.scss';

class App extends React.Component<any, any>{

  render() {
    return (
      <div className="App">
        <Switch>
          <Route exact path='/'>
            <Redirect to={routes.calculatorPage}/>
          </Route>
          <Route exact path={routes.calculatorPage} component={CalculatorPageView} />
          <Route component={ErrorPageView} />
        </Switch>
      </div>
    );
  }
}

export default App;
